function CheatSheet() {
  return (
   <iframe src="https://imperialwealth.com/betting/embed/bookmaker-intelligence" style={{ width: "100%", height: "100vh" }}></iframe>
  );
}

export default CheatSheet;